module.exports = __webpack_public_path__ + "img/banner_img02.24faa95e.png";